module.exports = __webpack_public_path__ + "media/images/t0007_008_20171208044443_w640z-1295850583fc936949614d689a0b69fa.jpg";